<table role="table">
  <caption class="cx-visually-hidden">
    {{
      'cartItems.caption' | cxTranslate
    }}
  </caption>
  <thead *ngIf="hasHeader">
    <tr role="row" class="cx-item-list-header">
      <th role="columnheader" class="cx-item-list-desc">
        {{ 'cartItems.item' | cxTranslate }}
      </th>
      <th role="columnheader" class="cx-item-list-desc" *ngIf="!isAsturias">
        {{ 'cartItems.width' | cxTranslate }}
      </th>
      <th role="columnheader" class="cx-item-list-desc">
        {{ 'cartItems.numberOfSheets' | cxTranslate }}
      </th>

      <ng-template
        role="columnheader"
        [cxOutlet]="CartOutlets.CPQ_QUOTE_HEADING"
        [cxOutletContext]="items"
      ></ng-template>
      <th
        role="columnheader"
        class="cx-item-list-qty"
        *ngIf="!isAsturias"
      >
        {{ 'cartItems.quantityPaquete' | cxTranslate }}
      </th>
      <th
        role="columnheader"
        class="cx-item-list-qty"
        *ngIf="isAsturias"
      >
        {{ 'cartItems.quantityTubos' | cxTranslate }}
      </th>
      <th
        role="columnheader"
        class="cx-item-list-qty"
      >
        {{ 'cartItems.weight' | cxTranslate }}
      </th>
      <th
        role="columnheader"
        class="cx-item-list-qty"
      >
        {{ 'cartItems.totalWeight' | cxTranslate }}
      </th>
      <th
        role="columnheader"
        class="cx-item-list-qty"
      >
        {{ 'cartItems.price' | cxTranslate }}
      </th>
      <th
        role="columnheader"
        class="cx-item-list-qty"
        *ngIf="options.isQuote"
      >
        {{ 'cartItems.newPrice' | cxTranslate }}
      </th>
      <th
        role="columnheader"
        class="cx-item-list-qty"
        *ngIf="!isAsturias && !options.isQuote"
      >
        {{ 'cartItems.offer' | cxTranslate }}
      </th>
      <th
        role="columnheader"
        class="cx-item-list-qty"
      >
        {{ 'cartItems.totalPrice' | cxTranslate }}
      </th>

      <ng-container
        *ngIf="!readonly || options.isSaveForLater || options.displayAddToCart"
      >
        <th role="columnheader" class="cx-item-list-actions">
          {{ 'cartItems.actions' | cxTranslate }}
        </th>
      </ng-container>
    </tr>
  </thead>
  <tbody class="cx-item-list-items">
    <ng-container *ngFor="let item of items; let i = index">
      <ng-container
        *ngIf="getControl(item) | async as control"
      >
        <tr
          cx-cart-item-list-row
          role="row"
          class="cx-item-list-row"
          [cartId]="cartId"
          [item]="item"
          [readonly]="readonly"
          [promotionLocation]="promotionLocation"
          [options]="options"
          [quantityControl]="getControlQuantity(control.get('quantity'))"
          [enableAddToCart]="false"
          [isAsturias]="isAsturias"
          [isQuote]="options.isQuote"
          [isSeller]="options.isSeller"
        ></tr>
      </ng-container>
    </ng-container>
  </tbody>
</table>

<ng-template #totalHeader>
  <th role="columnheader" class="cx-item-list-total">
    {{ 'cartItems.total' | cxTranslate }}
  </th>
</ng-template>
